import { normalizeLanguage } from './locale'

export function resolveAuthLanguage({ search = '', storedLanguage, browserLanguage } = {}) {
  const urlLanguage = new URLSearchParams(search).get('lang')
  return normalizeLanguage(urlLanguage, null)
    || normalizeLanguage(storedLanguage, null)
    || normalizeLanguage(browserLanguage)
}

export function buildAuthPageRoute(pathname, language, search = '') {
  const params = new URLSearchParams(search)
  params.set('lang', normalizeLanguage(language))
  return `${pathname}?${params.toString()}`
}
